import { Helmet } from "react-helmet-async";
import { t } from "i18next";
import { Alert, Col, Container, Row } from "react-bootstrap";
import BluetoothConnectButton from "./BluetoothConnectButton";
import { useState } from "react";
import DeviceDisplay from "./DeviceDisplay";
import BluetoothAvailabilityInfo from "./BluetoothAvailabilityInfo";
import { Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faAndroid, faChrome, faLinux, faWindows } from "@fortawesome/free-brands-svg-icons";
import BatteryGauge from "react-battery-gauge";
import Header from "./Header";

function ConnectView() {
    const [deviceL, setDeviceL] = useState(null);
    const [deviceR, setDeviceR] = useState(null);

    const [batteryStatusL, setBatteryStatusL] = useState(0);
    const [batteryStatusR, setBatteryStatusR] = useState(0);

    return (
        <>
            <Helmet>
                <title>{t("connect.title") + " - KooApp"}</title>
            </Helmet>

            <Header />

            <Container fluid="md">
                <h1 className="my-3">{t("connect.title")}</h1>

                <Alert variant="secondary" className={["mt-2", { "d-none": deviceL || deviceR }]}>
                    <p><FontAwesomeIcon icon={faInfoCircle} /> <Trans>connect.info</Trans></p>
                    <p>
                        <FontAwesomeIcon icon={faChrome} /> <Trans>connect.chrome <a target="_blank" rel="noreferrer" href="https://www.google.com/intl/ru_ru/chrome/"> </a></Trans> <FontAwesomeIcon icon={faWindows} /> <FontAwesomeIcon icon={faLinux} /> <FontAwesomeIcon icon={faAndroid} />
                    </p>

                    <p className="fst-italic small"><Trans>connect.flagsNote <a target="_blank" rel="noreferrer" href="chrome://flags"> </a></Trans></p>
                </Alert>

                <div className="mt-3">
                    <BluetoothAvailabilityInfo />
                </div>

                <Row className="align-items-baseline">
                    <Col xs={4} md={2}>
                        <h5 className="mt-3"><Trans>connect.left</Trans></h5>
                    </Col>
                    <Col xs={4} md={2}>
                        <BluetoothConnectButton deviceNamePrefix="Emitech KOO" deviceChanged={setDeviceL} />
                    </Col>
                    <Col xs={4} md={2}>
                        {deviceL && (
                            <BatteryGauge value={batteryStatusL} charging={batteryStatusL < 0} size={40} />
                        )}
                    </Col>

                    <Col xs={4} md={2}>
                        <h5 className="mt-3"><Trans>connect.right</Trans></h5>
                    </Col>
                    <Col xs={4} md={2}>
                        <BluetoothConnectButton deviceNamePrefix="Emitech KOO" deviceChanged={setDeviceR} />
                    </Col>
                    <Col xs={4} md={2}>
                        {deviceR && (
                            <BatteryGauge value={batteryStatusR} charging={batteryStatusR < 0} size={40} />
                        )}
                    </Col>
                </Row>

                {(deviceL || deviceR) && (
                    <DeviceDisplay deviceL={deviceL} deviceR={deviceR} batteryStatusChangedL={setBatteryStatusL} batteryStatusChangedR={setBatteryStatusR} />
                )}
            </Container>
        </>
    );
}

export default ConnectView;
